export default __webpack_public_path__ + "static/media/java.5e8cb917.svg";